export const getSitesAvailableToUser = (sites = [], user = {}) => {
  const allSites = Array.isArray(sites) ? sites : [];

  if (user.type !== 'user' && user.type !== 'buyer') {
    return allSites;
  }

  const accessList = (Array.isArray(user.access) ? user.access : []).map(String);

  return allSites.filter(site => accessList.includes(String(site._id)));
};
